import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import '../styles/hr-surface.css'

export function HrSurface({
  children,
  className,
  density = 'default',
}: {
  children: ReactNode
  className?: string
  /** editor: full-bleed, sıkı padding — belge şablon ekranları */
  density?: 'default' | 'editor'
}) {
  const isEditor = density === 'editor'
  return (
    <div className={cn('hr-surface', className)}>
      <div
        className={cn(
          'mx-auto flex w-full flex-col',
          isEditor ? 'max-w-none gap-4' : 'w-full gap-6',
          '[&>header]:mb-0',
        )}
      >
        {children}
      </div>
    </div>
  )
}
